import React,{useEffect,useState} from 'react';
import Helper from '../functions/Helper.js';
import { Swiper, SwiperSlide, } from 'swiper/react';
import Gallery from '../components/Gallery.js';

/** @jsx jsx */
import {jsx} from '@emotion/core'

export default function StyleModal(props){
  let activeStyle=props.styles[props.activeStyleId];
  const [swiper, updateSwiper] = useState(null);
  const [stylePictures,setStylePictures]=useState([]);
  const [activeSlide,setActiveSlide]=useState(0);
  const [showGallery,setShowGallery]=useState(false);

  useEffect(()=>{
    fetch(__server__ + '/API/pub/style_pictures/'+activeStyle.style_id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.json())
    .then((data)=>{
      setStylePictures(data);
    })
  },[])

  useEffect(()=>{
    if(stylePictures.length>0){

      if(typeof window.jQuery('.thg_style_modal_featherlight').featherlightGallery ==="function"){
        window.jQuery('.thg_style_modal_featherlight').featherlightGallery({variant:"style_modal_featherlight"});
      }
    }

  },[stylePictures])

  return(
      <div className="hover-swiper" css={{width:"100%",height:"100%"}}>
        { stylePictures &&
          <Gallery
            activeSlide={activeSlide}
            setActiveSlide={setActiveSlide}
            showGallery={showGallery}
            closeGallery={()=>{setShowGallery(false)}}
            pictures={stylePictures.map((x)=>({...x,master:x.url}))}/>
        }

        <div style={{padding:0,backgroundColor:"#f9f9f9",width:"100%"}}>
          <Swiper
            onActiveIndexChange={(x)=>{setActiveSlide(x.activeIndex)}}
            navigation={{nextEl: '.next-button-hover',prevEl: '.prev-button-hover'}}
            watchOverflow={true}
            spaceBetween={50}
            onSwiper={updateSwiper}
            observer={true}
            observeParents={true}
            pagination={{clickable: false}}>
            <SwiperSlide>
              <div  css={{padding:"20px 20px 50px","@media only screen and (min-width: 576px)":{paddingLeft:50,paddingRight:50},}}>
                <div style={{width:"100%",paddingBottom:"70%",position:"relative"}}>
                  <picture>
                    <source
                      type="image/webp"
                      data-srcset={Helper.create_source_set({master:activeStyle.picture_url,thumbnails:"1"},undefined,"webp")}
                      sizes="(max-width:576px) 500px, 585px"
                      />
                    <source
                      type="image/png"
                      data-srcset={Helper.create_source_set({master:activeStyle.picture_url,thumbnails:"1"})}
                      sizes="(max-width:576px) 500px, 585px"
                      />
                    <img
                      className="lazyload"
                      onClick={()=>{setShowGallery(true)}}
                      title={activeStyle.name}
                      css={{cursor:"zoom-in",position:"absolute",bottom:0,right:0,left:0,height:"100%",objectPosition:"bottom",width:"100%",transform: activeStyle.mirror==="1" ? "scaleX(-1)" :"",objectFit:"contain"}}
                      alt={activeStyle.name}
                      sizes="(max-width:576px) 100vw, 585px"
                      data-srcset={Helper.create_source_set({master:activeStyle.picture_url,thumbnails:"1"})}
                      data-src={Helper.add_options_img(activeStyle.picture_url,585)}
                      />
                  </picture>
                </div>
              </div>

            </SwiperSlide>
            {
              stylePictures.slice(1).map((picture,index)=>{

              return(
                <SwiperSlide key={index} >
                  <div css={{padding:"20px 20px 50px","@media only screen and (min-width: 576px)":{paddingLeft:50,paddingRight:50},}}>
                    <div style={{width:"100%",paddingBottom:"70%",position:"relative"}}>
                      <picture>
                        <source
                          type="image/webp"
                          srcSet={Helper.create_source_set({master:picture.url,thumbnails:"1"},undefined,"webp")}
                          sizes="(max-width:576px) 500px, 585px"
                          />
                        <source
                          type="image/png"
                          srcSet={Helper.create_source_set({master:picture.url,thumbnails:"1"})}
                          sizes="(max-width:576px) 500px, 585px"
                          />
                        <img
                          onClick={()=>{setShowGallery(true)}}
                          title={activeStyle.name}
                          className="lazyload"
                          css={{cursor:"zoom-in",position:"absolute",bottom:0,maxHeight:"90%",right:0,left:0,height:"100%",objectPosition:"bottom",width:"100%",transform: picture.mirror==="1" ? "scaleX(-1)" :"",objectFit:"contain"}}
                          alt={activeStyle.name}
                          sizes="(max-width:576px) 100vw, 585px"
                          data-srcset={Helper.create_source_set({master:picture.url,thumbnails:"1"})}/>
                      </picture>
                    </div>
                  </div>

              </SwiperSlide>
              );
            })
          }
          <div className="swiper-button-next next-button-hover"/>
          <div className="swiper-button-prev prev-button-hover"/>
        </Swiper>
          <button className="close" onClick={()=>{props.hideModal()}} style={{fontSize:50,padding:"10px 25px 25px 25px",lineHeight:1,color:"#000",position:"absolute",zIndex:1000,right:0,top:0,}} type="button" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div>

      {activeStyle.colorways.length>0 ?
        <div style={{maxWidth:500,margin:"auto",padding:"20px 20px 0px"}}>
          <div style={{fontWeight:700,fontSize:20,lineHeight:"25px"}}>
            {activeStyle.name}
          </div>
          <div style={{fontSize:14,marginTop:8,fontWeight:600,lineHeight:"14px",color:"#666666"}}>
            #{activeStyle.sku}
          </div>

          <div style={{marginBottom:5,marginTop:20,fontSize:16}}>
            Available from {activeStyle.colorways.length} {activeStyle.colorways.length>1 ? "shops":"shop"}:
          </div>
          <div style={{marginBottom:60}}>

            {activeStyle.colorways.map((colorway,index)=>{
              let discount=Math.round((1-(colorway.price_discount/colorway.list_price))*100);
              return(
                <div style={{display:"flex",flex:1,flexDirection:"row",padding:"8px 0px",borderTopWidth:1,borderBottomWidth:index===activeStyle.colorways.length-1 ? 1:0,borderColor:"#f0f0f0",borderStyle:"solid"}} key={colorway.colorway_id} >
                  <div style={{display:"flex",flexDirection:"column",justifyContent:"center"}}>
                    <div>
                      <div style={{color:"#333333",fontSize:16,lineHeight:1.3,fontWeight:500}}>
                      {colorway.shop_name}
                      </div>
                    </div>
                    <div style={{display:"flex",marginTop:2,lineHeight:1.3,flexDirection:"row"}}>
                      <div style={{fontWeight:"600",color:discount>1 ? "#e32b2b" :"black"}}>
                        ${colorway.price_discount}
                      </div>
                      {discount>1 &&
                        <div style={{color:"#767676",textDecorationLine:"line-through",textDecorationStyle: 'solid',marginLeft:5}}>
                          ${Math.round(Number(colorway.list_price))}
                        </div>
                      }
                    </div>
                  </div>
                  <div style={{display:"flex",flexDirection:"column",flex:1,justifyContent:"center",alignItems:"flex-end"}}>
                    <a target="_blank" rel="noopener nofollow" href={Helper.insert_link(colorway.link_url, props.linkId + "_modal_price",colorway.tracking_id)}
                      css={{":hover":{textDecoration:"none",color:"white"},color:"white",fontWeight:"700",borderRadius:2,padding:"8px 30px",fontSize:16,backgroundColor:"#FF5A5F",}}>
                      Buy Now
                    </a>
                  </div>
              </div>
              )
              /*
              return(
                {<div style={{display:"flex",height:55,borderBottom:"1px solid #eee"}} key={colorway.colorway_id}>

                  <div style={{display:"flex",alignItems:"center"}}>
                    <a target='_blank' rel='nofollow' href={Helper.insert_link(colorway.link_url, props.linkId + "_modal_banner",colorway.tracking_id)}>
                      <img alt="shop_banner" style={{height:35,maxWidth:130,objectFit:"contain"}} src={__cdn__ +"/"+ colorway.banner} />
                    </a>
                  </div>

                  <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"flex-end"}}>
                    <div style={{display:"flex"}}>
                      <a style={{color:"#ff5a5f",fontSize:20,textDecoration:"underline",textDecorationSkip:"none",textDecorationSkipInk:"none",fontWeight:"bold",}} target='_blank' rel='nofollow' href={Helper.insert_link(colorway.link_url, props.linkId + "_modal_price",colorway.tracking_id)}>
                        ${Number(colorway.price_discount).toFixed(2)}
                      </a>
                      {discount> 1 && props.showDiscount!==false &&
                        <div style={{textDecoration:"line-through",alignItems:"flex-end",display:"flex",marginLeft:5,fontSize:16}}>
                          ${Math.round(Number(colorway.list_price))}
                        </div>
                      }
                    </div>
                  </div>

                </div>
              ); */
              })
            }
          </div>
        </div>
        :
        <div style={{maxWidth:450, margin:"auto",paddingTop:20}}>
          <div style={{fontWeight:600,textAlign:"center",color:"#ff5a5f",}}>Found no store selling this colorway</div>
        </div>
      }
      </div>
    </div>
  )
}
